import type { ReactNode } from "react";
import { Link, NavLink } from "react-router-dom";
import { Building2 } from "lucide-react";
import { DriveLogo } from "@/components/shared/DriveLogo";
import { cn } from "@/lib/utils";
import { GlobalNavigation } from "./GlobalNavigation";
import { Header } from "./Header";

export function NavigationSidebar({ children }: { children: ReactNode }) {
  return (
    <div className="console-sidebar-slot">
      <aside className="console-sidebar">
        <Link to="/console/dashboard" className="flex h-14 shrink-0 items-center border-b px-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring">
          <span className="sidebar-logo"><span className="block w-[200px]"><DriveLogo /></span></span>
        </Link>
        {children}
      </aside>
    </div>
  );
}

export function ConsoleShell({ navigation, children }: { navigation: ReactNode; children: ReactNode }) {
  return (
    <div className="flex h-screen overflow-hidden">
      <a href="#main-content" className="skip-content-link">メインコンテンツへスキップ</a>
      {navigation}
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Header />
        <main id="main-content" tabIndex={-1} className="flex-1 overflow-auto focus:outline-none">
          {children}
        </main>
      </div>
    </div>
  );
}

export function AccountFrame({ children }: { children: ReactNode }) {
  return (
    <ConsoleShell navigation={
      <NavigationSidebar>
        <nav aria-label="登録メニュー" className="min-h-0 flex-1 overflow-y-auto px-2 py-3">
          <NavLink to="/console/dashboard" className={({ isActive }) => cn(
            "flex items-center gap-3 rounded-md border-l-2 px-3 py-2 text-sm font-medium",
            isActive ? "border-primary bg-accent text-accent-foreground" : "border-transparent text-muted-foreground hover:bg-accent hover:text-accent-foreground",
          )}>
            <Building2 className="h-4 w-4 shrink-0" aria-hidden="true" />
            <span className="sidebar-label">組織登録</span>
          </NavLink>
        </nav>
        <GlobalNavigation />
      </NavigationSidebar>
    }>
      {children}
    </ConsoleShell>
  );
}
